import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
// import { config } from 'webpack';
// import { createLogger } from 'redux-logger'
import rootReducer from "./reducer";

// const loggerMiddleware = createLogger()


// const DEBUG = false
const middleware = [
  thunkMiddleware,
  // loggerMiddleware
].filter(Boolean)

export default createStore(
  rootReducer,
  applyMiddleware(...middleware)
  )